module.exports = __webpack_public_path__ + "img/elipse-bottom.7eba53cd.png";